import { render } from "./qualificaProvvigioniSelector.vue?vue&type=template&id=5a52dc48&ts=true"
import script from "./qualificaProvvigioniSelector.vue?vue&type=script&lang=ts"
export * from "./qualificaProvvigioniSelector.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__